export default {
  API_ENDPOINT: 'http://localhost:8000/api',
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'cc70a9f0-016c-4a7b-8260-f9800dcc89a7',
}

